import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";

class PunchSizeMaster extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.itemMasterServices = new ItemMasterServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isEditing: false,
      isLoading: false,
      punchSizeList: [],
      tableStatus: "",
      punchSizeDetails: {
        punchSizeMaster: "",
      },
    };
  }

  componentDidMount() {
    this.getAllPunchSizes();
  }

  getAllPunchSizes = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllPunchSizes().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { punchSizeList: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  addEditPunchSizeMaster = () => {
    if (this.state.punchSizeDetails.punchSizeMaster !== "") {
      this.setState({ isLoading: true }, () => {
        let request = this.state.punchSizeDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices
          .addEditPunchSizeMaster(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
              this.resetForm();
              this.SwalServices.Success(response.Message);
              this.setState({ isLoading: false })
            } else {
              this.SwalServices.Error(
                response.Message
              );
              this.setState({ isLoading: false })
            }
          });
      })
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  resetForm = () => {
    let details = this.state.punchSizeDetails;
    details.punchSizeMaster = "";
    this.setState({ punchSizeDetails: details }, () => {
      this.setState({ _id: "", isEditing: false, tableStatus: "" }, () => {
        console.log(this.state._id);
        this.getAllPunchSizes();
      });
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.punchSizeDetails;
    details[name] = value.toUpperCase();
    this.setState({ punchSizeDetails: details });
  };

  getPunchSizeById = (group) => {
    let details = this.state.punchSizeDetails;
    details.punchSizeMaster = group.punchSizeMaster;
    this.setState({ punchSizeDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deletePunchSizeById = (id) => {
    this.itemMasterServices.deletePunchSizeById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllPunchSizes();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm();
  };

  render() {
    return (
      <div className="item-category">
        <div className="item-form">
          <div className="form-table ">
            <div className="item-grp !w-[50%] !mb-3.5">
              <label>Punch Size</label>
              <input
                className="inputFocus"
                type="text"
                id="punchSizeMaster"
                name="punchSizeMaster"
                autoComplete="off"
                value={this.state.punchSizeDetails.punchSizeMaster}
                onChange={(event) =>
                  this.handleChange(event, "punchSizeMaster")
                }
              />
            </div>
            <div className="btn-grp">
              {this.state.isEditing === true ? (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditPunchSizeMaster()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                </button>
              ) : (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditPunchSizeMaster()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                </button>
              )}
              <button className="cancel-btn" onClick={() => this.closeGridView()}>
                cancel
              </button>
            </div>
          </div>
          <div className="itemList-table !w-[60%] mt-4">
            <div className="table-container" style={{ height: 'calc(100vh - 185px)', }}>
              <table className="itemList">
                <thead>
                  <tr>
                    <td style={{ width: '85%' }}>Punch Size</td>
                    <td style={{ width: '15%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.punchSizeList &&
                    this.state.punchSizeList.length > 0 ?
                    this.state.punchSizeList.map((group, key) => (
                      <tr key={key}>
                        <td>{group.punchSizeMaster}</td>
                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getPunchSizeById(group)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={() => this.deletePunchSizeById(group._id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    )) : this.state.punchSizeList &&
                      this.state.punchSizeList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.punchSizeList &&
                      this.state.punchSizeList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PunchSizeMaster;
